import { env } from "@/config/env";

export type PublicFormIdentifier = string | number;

export function getFormPublicIdentifier(form: {
  id: number;
  publicId?: string | null;
}): string {
  const publicId = form.publicId?.trim();
  return publicId || String(form.id);
}

export function getPublicFormPath(identifier: PublicFormIdentifier): string {
  return `/forms/${encodeURIComponent(String(identifier))}`;
}

export function getPublicFormUrl(identifier: PublicFormIdentifier): string {
  return `${env.publicFormsBaseUrl}${getPublicFormPath(identifier)}`;
}
